import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { isPushSupported, subscribeUserToPush } from '../lib/pushService';

/**
 * Silent push auto-subscriber. If permission is already granted, ensures
 * the device is subscribed. Does NOT prompt unless the user clicks the
 * dedicated "Activer les notifications" button in Profile.
 */
export function PushAutoSubscribe() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user?.id || !isPushSupported()) return;
    if (typeof Notification === 'undefined') return;
    if (Notification.permission !== 'granted') return;
    // Already granted: silently (re)register endpoint.
    subscribeUserToPush(user.id).catch(() => {});
  }, [user?.id]);

  return null;
}
